import React from 'react'
import Wrapper from '../src/components/nav-wrapper.js'

const wrapper = ({ element, props }) => {
  return (<Wrapper {...props}>{element}</Wrapper>)
}
export default wrapper